import React, { useState, useEffect, useRef } from "react";
import { DownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import "./LoggedInHeaderCategories.css";

function LoggedInHeaderCategories() {
  const [coursesMenuOpen, setCoursesMenuOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        const menuButton = document.querySelector('.courses-drop-down');
        if (menuButton && !menuButton.contains(event.target)) {
          setCoursesMenuOpen(false);
        }
      }
    };

    if (coursesMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [coursesMenuOpen]);

  const toggleCoursesMenu = (e) => {
    e.stopPropagation();
    setCoursesMenuOpen(!coursesMenuOpen);
  };

  const educationLevels = {
    "Kindergarten": ["Basic Literacy", "Numeracy", "Art & Creativity"],
    "Primary School": {
      "Lower Primary": ["English", "Mathematics", "Environmental Studies"],
      "Upper Primary": ["Science", "Social Studies", "Kiswahili"]
    },
    "Secondary": {
      "O-Level": ["Physics", "Chemistry", "Biology"],
      "A-Level": ["Advanced Mathematics", "Economics", "Commerce"]
    }
  };

  const handleNavigateToCourses = (coursePath) => {
    navigate("/courses", { state: { filter: coursePath } });
    setCoursesMenuOpen(false);
  };

  const handleExploreClick = () => navigate("/user-classes");

  const handleNavigateToExams = () => navigate("/exam-system")

  return (
    <div className="header-categories-container" ref={menuRef}>
      <div className="header-categories-row">
        <div className="courses-drop-down" onClick={toggleCoursesMenu}>
          <span className="courses-categories">Classes</span>
          <DownOutlined className={`down-arrow-courses ${coursesMenuOpen ? "rotate" : ""}`} />
        </div>
        <span className="explore-categories" onClick={handleExploreClick}>
          My Classes
        </span>
         <span className="explore-categories" onClick={handleNavigateToExams}>Exams</span>
      </div>
      
      {coursesMenuOpen && (
        <DropdownMenu 
          educationLevels={educationLevels} 
          onItemClick={handleNavigateToCourses} 
        />
      )}
    </div>
  );
}

export default LoggedInHeaderCategories;